import styled from "styled-components";

export const Container = styled.div`
    h3{
        font-size: 18px;
        line-height: 28px;
        font-weight: 900;
        color: #000;
        margin-bottom: 24px;
    }
`;